import * as Types from '../../generated-types';

import { GraphQLClient } from 'graphql-request';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

function fetcher<TData, TVariables extends { [key: string]: any }>(client: GraphQLClient, query: string, variables?: TVariables, requestHeaders?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request({
    document: query,
    variables,
    requestHeaders
  });
}
export type CreateHoursOffMutationVariables = Types.Exact<{
  dayId: Types.Scalars['ID'];
  from: Types.Scalars['Time'];
  to: Types.Scalars['Time'];
}>;


export type CreateHoursOffMutation = { __typename?: 'Mutation', createHoursOff?: { __typename?: 'HoursOff', documentId: string, from?: any | null, to?: any | null } | null };

export type UpdateHoursOffMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  from?: Types.InputMaybe<Types.Scalars['Time']>;
  to?: Types.InputMaybe<Types.Scalars['Time']>;
}>;


export type UpdateHoursOffMutation = { __typename?: 'Mutation', updateHoursOff?: { __typename?: 'HoursOff', documentId: string, from?: any | null, to?: any | null } | null };

export type DeleteHoursOffMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type DeleteHoursOffMutation = { __typename?: 'Mutation', deleteHoursOff?: { __typename?: 'DeleteMutationResponse', documentId: string } | null };


export const CreateHoursOffDocument = `
    mutation CreateHoursOff($dayId: ID!, $from: Time!, $to: Time!) {
  createHoursOff(data: {day: $dayId, from: $from, to: $to}) {
    documentId
    from
    to
  }
}
    `;
export const useCreateHoursOffMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateHoursOffMutation, TError, CreateHoursOffMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateHoursOffMutation, TError, CreateHoursOffMutationVariables, TContext>(
      ['CreateHoursOff'],
      (variables?: CreateHoursOffMutationVariables) => fetcher<CreateHoursOffMutation, CreateHoursOffMutationVariables>(client, CreateHoursOffDocument, variables, headers)(),
      options
    );
export const UpdateHoursOffDocument = `
    mutation UpdateHoursOff($id: ID!, $from: Time, $to: Time) {
  updateHoursOff(documentId: $id, data: {from: $from, to: $to}) {
    documentId
    from
    to
  }
}
    `;
export const useUpdateHoursOffMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateHoursOffMutation, TError, UpdateHoursOffMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateHoursOffMutation, TError, UpdateHoursOffMutationVariables, TContext>(
      ['UpdateHoursOff'],
      (variables?: UpdateHoursOffMutationVariables) => fetcher<UpdateHoursOffMutation, UpdateHoursOffMutationVariables>(client, UpdateHoursOffDocument, variables, headers)(),
      options
    );
export const DeleteHoursOffDocument = `
    mutation DeleteHoursOff($id: ID!) {
  deleteHoursOff(documentId: $id) {
    documentId
  }
}
    `;
export const useDeleteHoursOffMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteHoursOffMutation, TError, DeleteHoursOffMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteHoursOffMutation, TError, DeleteHoursOffMutationVariables, TContext>(
      ['DeleteHoursOff'],
      (variables?: DeleteHoursOffMutationVariables) => fetcher<DeleteHoursOffMutation, DeleteHoursOffMutationVariables>(client, DeleteHoursOffDocument, variables, headers)(),
      options
    );